import React from 'react'
import Navigation from '../layout/Navigation'

const Contact = () => {
    return (
        <>
            <Navigation title="Raunak Kesarwani" />
        </>
    )
}

export default Contact;